<div class="row" style="margin-bottom: 20px; margin-bottom: 20px;">
  <div class="col-lg-11">
    <angular-editor
  [placeholder]="'Enter text here...'"
  [(ngModel)]="htmlContent"
  [config]="EditorConfig"
></angular-editor>
  </div>
</div>

